export default "__VITE_ASSET__Dgz0PsFz__"